import { z } from "zod";
import { CATEGORY_NAME, DESCRIPTION, PROPERTY_CATEGORY } from "./consts";

export const schema = z.object({
  [CATEGORY_NAME]: z.string().min(1, "This field is required"),
  [PROPERTY_CATEGORY]: z.array(z.string()).min(1, "This field is required"),
  [DESCRIPTION]: z.string().optional(),
});

export type AddModelFormValues = z.infer<typeof schema>;
